import { useQueryClient, useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionsKey, getSpaceKey, getSpacesKey, getUpdateSpaceKey, } from '../../utils/keys';
export const useUpdateSpace = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const collectionsKey = getCollectionsKey({});
    return useMutation((input) => client.spaces.update(input, fields), {
        onMutate: async (newSpace) => {
            const spaceKey = getSpaceKey({ id: newSpace.id });
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries(spaceKey);
            // Snapshot the previous value
            const snapshot = queryClient.getQueryData(spaceKey);
            // Optimistically update to the new value
            queryClient.setQueryData(spaceKey, old => ({
                ...old,
                ...newSpace,
            }));
            // Return a context object with the snapshotted value
            return { snapshot };
        },
        onSuccess: data => {
            queryClient.invalidateQueries(collectionsKey);
            const spaceKey = getSpaceKey({ id: data.id });
            queryClient.setQueryData(spaceKey, oldData => ({
                ...oldData,
                ...data,
            }));
        },
        onError: (err, newSpace, context) => {
            const spaceKey = getSpaceKey({ id: newSpace.id });
            // revert back the optimistic response
            queryClient.setQueryData(spaceKey, context.snapshot);
            // invalidate to refetch again
            queryClient.invalidateQueries(spaceKey);
        },
        onSettled: () => {
            const spacesKey = getSpacesKey();
            queryClient.invalidateQueries(spacesKey);
        },
        mutationKey: getUpdateSpaceKey(),
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateSpace.js.map